// extracted by mini-css-extract-plugin
module.exports = {"scrollTop":"ScrollToTop_scrollTop__23Dsc","fadeIn":"ScrollToTop_fadeIn__woOyv"};